<template>
    
    <div class="media-video">
        <div 
            class="video-container"
            ref="videoContainer"
            :style="{ paddingBottom: padding+'%', backgroundColor: backgroundColor}"
        >

            <video-loader
                ref="video"
                :data="data.video.urls"
                :autoplay=true 
                :loop=true
                @loaded="onVideoLoaded"
            />
        </div>
    </div>
    
</template>


<script>
import VideoLoader from '@/components/VideoLoader'
import Size from '@/plugins/WindowSize'
import Observer from '@/plugins/Observer'

export default {
    
    props: {
        data: {
            type: Object,
            required: true,
            // default: () => {},
        }
    },
    
    components: {
        VideoLoader
    },
    
    data() {
        return {
            backgroundColor: '',
            padding: 0,
        }
    },
    
    created() {
        Size.addListener(this.onResize)
        this.backgroundColor = this.data.backgroundColor
    },
    
    destroyed() {
        Size.removeListener(this.onResize)
        
        this.observer.destroy()
    },
    
    mounted() {
        let width = this.data.video.urls[0].width
        let height = this.data.video.urls[0].height
        
        this.aspectRatio = height/width;
        
        this.onResize()
        
        this.observer = new Observer(this.$refs.videoContainer, this.onEnter, this.onLeave)
    },
    
    methods: {
        
        onEnter() {
            // this.$refs.videoContainer.style.visibility = 'visible'
            this.$refs.video.play()
        },
        
        onLeave() {
            // this.$refs.videoContainer.style.visibility = 'hidden'
            this.$refs.video.pause()
        },

        onVideoLoaded() {
            // this.backgroundColor = 'transparent'
            this.$emit('loaded')
        },

        onResize() {
            if (this.$refs.videoContainer !== undefined) {
                
                this.containerWidth = this.$refs.videoContainer.offsetWidth
                var containerHeight;
                
                // Round the height of images to closest 10, 20 or 30px.
                // This way we can assure that the grid items have same 
                // space beneath. Check rowHeight & rowSpan in Work.vue
                if (this.$router.currentRoute.name === 'Work' || this.$router.currentRoute.name === 'WorkFilter') {
                    var rowHeight = (window.innerWidth < 1024) ? 10 : (window.innerWidth < 1440) ? 20 : 30;
                    containerHeight = Math.round(this.containerWidth*this.aspectRatio / rowHeight) * rowHeight; // round off to each 20 - Fit the /work grid!
                }
                // Case page
                else {
                    containerHeight = this.containerWidth*this.aspectRatio;
                }
                
                this.padding = (containerHeight / this.containerWidth) * 100
            }
        },
    },
}

</script>


<style lang="scss" scoped>
@import '../scss/variables';
  
.video-container {
    position: relative;
    height: 0;
    
    video {
        position: absolute;
        object-fit: cover;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 2s ease-out;
        
        &.loaded {
            opacity: 1;    
        }
    }
}
</style>
